import TireSetSelection from './TireSetSelection';
export default TireSetSelection;
